<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Yeni Dil Ekle">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span><strong>Not:</strong> Eklenecek dil benzersiz olmalıdır...</span>
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            to="/languages"
          >
            Dil Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Dil Ekleme Formu">
            <b-row>
              <b-col cols="6">
                <b-form-group label="Dil Adı" label-for="name">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Dil Adı"
                  >
                    <b-form-input
                      id="name"
                      v-model="name"
                      placeholder="Dil Adı"
                      :state="errors.length > 0 ? false : null"
                      :class="name.length >= chars.name ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="name.length >= chars.name ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ name.length }}</span>
                      /
                      {{ chars.name }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Kod" label-for="code">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Kod"
                  >
                    <b-form-input
                      id="code"
                      v-model="code"
                      placeholder="Kod"
                      :state="errors.length > 0 ? false : null"
                      :class="code.length >= chars.code ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="code.length >= chars.code ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ code.length }}</span>
                      /
                      {{ chars.code }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <DragDropImage
                  v-if="flag != null"
                  ref="refFlagImage"
                  title="Bayrak Görseli"
                  :imageUrl="flag"
                  :required="false"
                ></DragDropImage>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12" class="mt-5">
                <div>
                  <b-button
                    class="float-right mt-2"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success"
                    @click="postConfirmText(false)"
                  >
                    <b-spinner v-if="spinner === true && isDraft === false" small />
                    {{
                      spinner === true && isDraft === false ? "Yayınlanıyor" : "Yayınla"
                    }}
                  </b-button>
                </div>
                <div>
                  <b-button
                    class="float-right mt-2 mr-1"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-warning"
                    @click="postConfirmText(true)"
                  >
                    <b-spinner v-if="spinner == true && isDraft == true" small />
                    {{
                      spinner == true && isDraft == true
                        ? "Taslağa Kaydediliyor"
                        : "Taslağa Kaydet"
                    }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import Editor from "../components/Editor";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    Editor,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      id: this.$route.params.idParam,
      name: '',
      code: '',
      flag: null,
      isDraft: false,
      spinner: false,
      chars: {
        name: 255,
        code: 2,
      },
    };
  },
  watch: {},
  methods: {
    getLanguageById() {
      endpoints
        .getLanguageById(this.id,this.$i18n.locale, () => {})
        .then((data) => {
          this.name = data.response.name;
          this.code = data.response.code;
          this.isDraft = data.response.isDraft;
          this.flag = data.response.flag;
          
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postConfirmText(isDraft) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Dili güncellemek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let formData = new FormData();
          formData.append("id", this.id);
          formData.append("name", this.name);
          formData.append("code", this.code);
          formData.append("isDraft", this.isDraft ? 1 : 0);
          if (this.$refs.refFlagImage.image != null) {
            formData.append("flag", this.$refs.refFlagImage.image);
            
          }

          endpoints
            .putLanguage(formData, this.$i18n.locale, () => {})
            .then((data) => {
              this.spinner = false;
              if (data.status) {
                this.$swal({
                  icon: "success",
                  title: "Kayıt başarılı!",
                  text: "Dil Güncellendi.",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result) => {
                  if (result.value) {
                    this.$router.push({
                      path: `/languages`,
                    });
                  }
                });
              } else {
                this.$swal({
                  title: "Hata!",
                  text: "Dil benzersiz değil!",
                  icon: "error",
                  confirmButtonText: "Tamam",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                }).then((result) => {
                  if (result.value) {
                  }
                });
              }
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
  },
  created() {},
  destroyed() {},
  mounted() {
    this.getLanguageById();
  },
  setup() {},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
